import PillarRow from './PillarRow';

export default function HeroSection() {
  return (
    <section
      id="top"
      className="flex flex-col items-center px-6 pb-24 pt-24 text-center sm:pb-32 sm:pt-32"
    >
      <h1
        className="m-0 text-[#2B2414] font-display"
        style={{
          fontWeight: 400,
          fontSize: 'clamp(88px, 18vw, 192px)',
          lineHeight: 0.95,
          letterSpacing: '-0.045em',
        }}
      >
        HELIOS
      </h1>

      <p
        className="mt-10 max-w-xl text-[#5E5138] font-body"
        style={{
          fontWeight: 400,
          fontSize: 'clamp(18px, 2.4vw, 22px)',
          lineHeight: 1.45,
          letterSpacing: '-0.011em',
        }}
      >
        The app for the complete — and aspiring — athlete.
      </p>

      <div className="mt-16">
        <PillarRow />
      </div>

      <a
        href="#waitlist"
        className="mt-16 inline-flex items-center justify-center rounded-full bg-[#9E2D1B] px-8 text-[#F2ECE0] no-underline transition-colors duration-200 hover:bg-[#8A2717] font-body"
        style={{
          fontWeight: 500,
          fontSize: 15,
          letterSpacing: '-0.006em',
          minHeight: 48,
        }}
      >
        Join Waitlist
      </a>

      <p
        className="mt-6 text-[#7B7162] font-mono"
        style={{
          fontWeight: 500,
          fontSize: 11,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
        }}
      >
        Launching summer 2026
      </p>
    </section>
  );
}
